import BloodGlucoseFormContext from "../../../model/BloodGlucoseFormContext";
import Exercise from "../../../model/Exercise";
import QuickCheckReason from "../../../model/QuickCheckReason";

export const titleForContext = (context: BloodGlucoseFormContext) => {
  switch (context) {
    case "fasting":
      return "Fasting";
    case "snack-before-breakfast":
      return "Snack";
    case "breakfast":
      return "Breakfast";
    case "snack-between-breakfast-and-lunch":
      return "Snack";
    case "lunch":
      return "Lunch";
    case "snack-between-lunch-and-dinner":
      return "Snack";
    case "dinner":
      return "Dinner";
    case "snack-after-dinner":
      return "Snack";
    case "quick-check":
      return "Quick check";
  }
};

export const titleForQuickCheckReason = (reason: QuickCheckReason) => {
  switch (reason) {
    case "curious":
      return "Curious";
    case "medication-change":
      return "Medication change";
    case "tired":
      return "Tired";
    case "dizzy":
      return "Dizzy";
    case "light-headed":
      return "Light-headed";
    case "nausea":
      return "Nausea";
    case "decreased-fetal-movement":
      return "Decreased fetal movement";
    case "other":
      return "Other";
  }
};

export const titleForExercise = (exercise: Exercise) => {
  switch (exercise) {
    case "none":
      return "None";
    case "light":
      return "Light";
    case "moderate":
      return "Moderate";
    case "vigorous":
      return "Vigorous";
  }
};
